/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of  InventoryPurchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {  InventoryPurchaseApi } from './../../api/transaction/purchase.api';
import {  InventoryPurchaseData,  InventoryPurchase, SupplierInvoice } from './../../interface/transaction/purchase';

@Injectable()
export class  InventoryPurchaseService extends  InventoryPurchaseData {

  constructor(private api:  InventoryPurchaseApi) {
    super();
  }



  list(url: string): Observable< InventoryPurchase[]> {
    return this.api.list(url);
  }
searchList(url: string,data:any): Observable<any> {
   
      return this.api.searchList(url,data);
    }
     distinctSupplier(url: string): Observable<any> {
    return this.api.distinctSupplier(url);
    }
    consolidSupplierWiseReport(url: string,data:any): Observable<any> {
   
      return this.api.searchList(url,data);
    }
     consolidDateWiseReport(url: string,data:any): Observable<any> {
    
      return this.api.searchList(url,data);
    }
 supplierList(url: string): Observable< InventoryPurchase[]> {
  
    return this.api.list(url);
  }
  supplierInvoiceListById(url: string): Observable<SupplierInvoice> {
 
    return this.api.invoiceListById(url);
  }
  supplierInvoiceList(url: string): Observable<SupplierInvoice[]> {

    return this.api.invoiceList(url);
  }
  getById(url:string): Observable< InventoryPurchase>{
      return this.api.getById(url);
  }

  create(url: string, data: InventoryPurchase): Observable< InventoryPurchase> {
    return this.api.add(url,data);
  }

  searchSupplier_Inv_List(url: string,data:any): Observable<any> { 
   
    return this.api.searchSupplier_Inv_List(url,data);
  }

  update(url: string, data: InventoryPurchase): Observable< InventoryPurchase> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  
  searchInv_List(url: string): Observable< InventoryPurchase[]> {
    return this.api.searchInv_List(url);
  }

}
